module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-30_615320c5390b64aa3732ab65574caa02.png";